import { Minus, Plus } from 'lucide-react'
import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface ExpandableHeadProps extends ComponentProps<'span'> {
  isExpanded: boolean
  minorIcon?: boolean
}

export function ExpandableHead({
  isExpanded,
  className,
  minorIcon,
  ...props
}: ExpandableHeadProps) {
  return (
    <span
      className={twMerge(
        'cursor-pointer text-bios-primary/90 transition-all duration-300 *:size-6 hover:text-bios-secondary',
        className,
      )}
      {...props}
    >
      {isExpanded ? (
        minorIcon ? (
          <Minus className="size-5 max-h-5 max-w-5" />
        ) : (
          <Minus />
        )
      ) : minorIcon ? (
        <Plus className="size-5 max-h-5 max-w-5" />
      ) : (
        <Plus />
      )}
    </span>
  )
}
